module.exports = __webpack_public_path__ + "static/img/coupon-bg.c2d99bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon-bg.png
// module id = ZR1K
// module chunks = 0